import React, { useState } from "react";
import {  Toast } from "../../Components";

export default function AdminHome({ setAuth, setModal, NotifModul, account, setModalSwitch, setModalNotification, user,
    profiles, }) {

    const [toastList, setToastList] = useState([]);
    return (
        <>
            <div className="main">
                <div className="main__inner">
                    <div className="main__inner-title">
                        <div className="main__inner-title-col extra">
                            <h2>Home</h2>

                        </div>

                        {/* <Profile
                            user={user}
                            setModal={setModalSwitch}
                            NotifModul={NotifModul}
                            profiles={profiles}
                            setNotifModul={setModalNotification}
                        /> */}
                    </div>
                    <div className="recom">

                    </div>
                </div>
            </div>

            {toastList && (
                <Toast type="rate" list={toastList} setList={setToastList} />
            )}
        </>
    );
}
